import { Helmet } from "react-helmet-async";
import { Search, Shield, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ServiceInspection = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Inspection du système de traite - Agroref</title>
        <meta name="description" content="Inspection complète de votre système de traite pour garantir performance et qualité" />
      </Helmet>
      
      
      <main className="flex-1">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/10 to-primary/5 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                Inspection du système de traite
              </h1>
              <p className="text-xl text-muted-foreground">
                Une inspection complète et rigoureuse pour garantir le bon fonctionnement et la performance de votre système
              </p>
            </div>
          </div>
        </section>

        {/* Services Details */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <Card>
                  <CardContent className="pt-6">
                    <Search className="h-12 w-12 text-primary mb-4" />
                    <h3 className="text-xl font-semibold mb-3">Inspection détaillée</h3>
                    <p className="text-muted-foreground">
                      Analyse approfondie de tous les composants de votre système de traite selon les normes les plus strictes.
                    </p>
                  </CardContent>
                </Card>

                <Card>
                  <CardContent className="pt-6">
                    <Shield className="h-12 w-12 text-primary mb-4" />
                    <h3 className="text-xl font-semibold mb-3">Conformité garantie</h3>
                    <p className="text-muted-foreground">
                      Vérification de la conformité de votre installation aux normes et réglementations en vigueur.
                    </p>
                  </CardContent>
                </Card>
              </div>

              <div className="bg-card rounded-lg p-8 shadow-sm">
                <h2 className="text-2xl font-bold mb-6">Points d'inspection</h2>
                <div className="space-y-4">
                  {[
                    "Vérification du système de vide et de ses composants",
                    "Inspection des gobelets trayeurs et manchons",
                    "Contrôle des pulsateurs et de leur réglage",
                    "Analyse du système de refroidissement du lait",
                    "Vérification des systèmes de nettoyage automatique",
                    "Contrôle de l'état des tubulures et raccords",
                    "Test de performance globale du système",
                    "Rapport détaillé avec recommandations"
                  ].map((service, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle className="h-6 w-6 text-primary flex-shrink-0 mt-0.5" />
                      <p className="text-muted-foreground">{service}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-primary/5 py-16">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Planifiez votre inspection</h2>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Assurez la performance optimale de votre système de traite
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
            >
              <Search className="h-5 w-5" />
              Demander une inspection
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ServiceInspection;
